import { ColDef, ColumnApi, GridApi } from 'ag-grid-community';

import { IDataQuery } from '../data-query';
import { sanitizeFilterModel } from '../utils';

export function generateDataQuery(gridApi: GridApi, columnApi: ColumnApi): IDataQuery {
  const currentFilterModel = gridApi.getFilterModel();

  return {
    filterModel: {
      ...currentFilterModel,
      ...sanitizeFilterModel(currentFilterModel, columnApi),
    },
    columnsDefinition: gridApi.getColumnDefs().map((colDef: ColDef) => ({
      field: colDef.field,
      headerName: colDef.headerName,
      hide: colDef.hide,
      rowGroup: colDef.rowGroup,
      rowGroupIndex: colDef.rowGroupIndex,
      sort: colDef.sort,
      sortIndex: colDef.sortIndex,
      type: colDef.type,
    })),
  };
}
